export const c_table__sticky_cell_MinWidth = {
  "name": "--pf-v5-c-table__sticky-cell--MinWidth",
  "value": "12.5rem",
  "var": "var(--pf-v5-c-table__sticky-cell--MinWidth)"
};
export default c_table__sticky_cell_MinWidth;